export default __webpack_public_path__ + "static/media/contactus-bg3.09520447.jpg";